import React, { useEffect, useState, useCallback } from 'react';
import LayoutSvg from 'components/layout_and_quote_builder/quote_builder/LayoutSvg.jsx'
import FrankSolutionSvgTable from 'components/frank/FrankSolutionSvgTable.jsx'
import QuoteBuilder from 'components/layout_and_quote_builder/quote_builder/QuoteBuilder.jsx'
import { SelectedMachinesContext } from 'components/layout_and_quote_builder/quote_builder/selectedMachinesContext.js'
import { Tooltip } from 'components/common';
import { PostRequest } from 'components/common/index.js';

const QuoteBuilderNavColumn = ({ index, config, item, options, multipleColumns, presentedOptions, setItems, navSection, colIndex, getExtraItems, selectedList, setSelectedList}) => {

  const QuoteBuilderEnabled = true;

  // The machine each price dropdown below is set to, keyed by column ('printing' / 'die_cutting'), so the SVG
  // header names the machine the price is actually for. The machine price fields report through the context;
  // null clears a column back to no name (nothing selected).
  const [selectedMachines, setSelectedMachines] = useState({});
  const setSelectedMachine = useCallback((column, machine) => {
    setSelectedMachines((previous) => {
      // A price field re-reports on every list refetch; bail when the machine is unchanged so the SVG header
      // (two injected SVGs) does not re-render for a value that did not actually change.
      const current = previous[column];
      const unchanged = current === machine
        || (!current && !machine)
        || (current && machine && current.name === machine.name && current.typeLabel === machine.typeLabel);
      return unchanged ? previous : { ...previous, [column]: machine };
    });
  }, []);
  // /quote-builder/reset-nav-column/:user_quote_id/:item_uuid/:extra_item_reason
  const onDestruct = () => {
    if(item.is_item_extra) {
      PostRequest({
        url: `/quote-builder/reset-nav-column/${window.user_quote_id}/${item.uuid}/${item.extra_item_reason}`,
        data: {},
        callback: (data) => {
          // console.log({data})
        }
      })
    }
    console.log({
      onDestruct: 'onDestruct',
      item: item,
    })

  }

  useEffect(() => {
    return onDestruct;
  }, []);


  const extraItemReasonDescription = () => {
    return (
      <span className="float-right">
        <Tooltip title={t('quote_builder.extra_item_reason_' + item.extra_item_reason)} style="info" isSmall={true} hint={t('quote_builder.column_information')} />
      </span>
    );
  }

  const Svg = () => {
    if(item.klass == 'Drawing') {
      return; // we need a DrawingSvg component here
    }

    // /mcc (Frank) renders its own priced-solution SVG table so it can diverge from the frozen legacy page; the
    // legacy /manufacturing-cost-calculator keeps LayoutSvg. FrankSolutionSvgTable is a fork of it, same props.
    const SolutionSvgComponent = window.frank_mode ? FrankSolutionSvgTable : LayoutSvg;

    return <SolutionSvgComponent
      index= {index}
      item={item}
      options={options}
      presentedOptions={presentedOptions}
      navSection={navSection}
      selectedList={selectedList}
      multipleColumns={multipleColumns}
      setSelectedList={setSelectedList}
      selectedMachines={selectedMachines}
    />
  }

  const columnTitle = () => {
    if(navSection.part_type == 'carton_lamination' || ['lamination_extra_item_one'].includes(item.extra_item_reason)) {
      return t('quote_builder.column_title_lamination');
    }

    return ""
  }

  const showColumnTitle = () => {
    if(columnTitle() != "") {
      return (
        <span className="float-right">
          <strong> {columnTitle()}  </strong>
        </span>
      )
    }

    return <br />;
  }


  const navSectionColumnType = () => {
    if(item.navSectionType != undefined) {
      return item.navSectionType;
    }
    return navSection.navSectionType;
  }

  const navSectionInfo = () => {
    return <small> [Kolon: {navSectionColumnType()}] </small>
  }

  return (<SelectedMachinesContext.Provider value={setSelectedMachine}>
     {window.isAdmin && navSectionInfo() }

    <div className="quote_builder_container">

      {Svg()}

      {false && navSection.label != 'General' &&  navSection.label != 'Genel' && navSection.label != '' && navSection.label != undefined && (<div className="float-right">
        <h3> { navSection.label } </h3>
      </div>)}

      {showColumnTitle()}

      {item.extra_item_reason != undefined && extraItemReasonDescription() }

      {QuoteBuilderEnabled && <QuoteBuilder
        item={item}
        config={config}
        options={options}
        navSection={navSection}
        columnTitle={columnTitle()}
        colIndex={colIndex}
        getExtraItems={getExtraItems}
        navSectionColumnType={navSectionColumnType()}
      />}

    </div>
   </SelectedMachinesContext.Provider>)
}

export default QuoteBuilderNavColumn;
